import PageHeader from "../components/page-header"
import plusIcon from "../assets/img/plus-icon.svg"
import searchIcon from "../assets/img/search-icon.svg"
import dotsIcon from "../assets/img/dots.svg"
import chevron_down_greyIcon from "../assets/img/chevron-down-gray.svg"
import defaultIcon from "../assets/img/products/default.png"
import { ChevronRight } from "../utils/svg"
import "../assets/css/monetization.css"
import * as $ from "jquery"
import { useEffect, useState } from "react"
import { Route, useHistory, useLocation } from "react-router-dom"
import Skeleton from "react-loading-skeleton"
import SideBar from "../components/side-bar"
import { useDispatch, useSelector } from "react-redux"
import getProducts from "../services/getProducts"
import { hideLoader, showLoader } from "../components/loader"
import { audiencePosts as productPosts } from "../services/postRequests/audience"
import { apiUrl, pageUrl } from "../utils/url"
import { toast } from "react-toastify"
import CommunityFooter from "../components/community/footer"
import HeaderSearch from "../components/community/headerSearch"
import ConfirmationModal from "../components/confirmation-modal"
import ConnectModal from "../components/connect-modal"
import upgradeSubmit from "../components/upgrade/upgrade-button"
import { disconnectPayout } from "../components/upgrade/upgrade-button"
import PayoutSettings from "../components/payout-settings"
import { DisconnectPayoutModal } from "../components/payout-settings"
import DisonnectModal from "../components/disconnect-modal"
import ProductTypeModal from "../components/products/product_type_modal"
import yellowCircle from "../assets/img/yellow-circle.svg"
import redCircle from "../assets/img/red-circle.svg"
import purpleCircle from "../assets/img/purple-circle.svg"
import defaultProductImage from "../assets/img/products/default-Product-image"
import ConnectCalendarModal from "../components/connect-calendar-modal"
import NewSideBar from "../components/side-bar/new-sidebar"
import tickIcon from "../assets/img/tick.svg"
import Teammoadal from "../components/teammember/team_modal"
import EmptyState from "./empty-state"
import ExportSteps from "../components/products/product-settings/product-tabs/exports/export-steps"
import ProductMain from "../components/products/product-main"

const mainPath = "products";
const subPath = "newProducts";

let params = [];

const Products = ({ basePath, id }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    let location = useLocation();
    const [title, setTitle] = useState();
    const [loading, setloading] = useState(true);
    // const [showNewProducts, setShowNewProducts] = useState(false);
    const [isEdit, setIsEdit] = useState({ is: false, id: null })
    const { slug } = useSelector(state => state?.slugReducer);
    const [allProducts, setallProducts] = useState([]);
    const [payoutSettingsModal, setpayoutSettingsModal] = useState(false);
    const [payoutDisconnectModal, setpayoutDisconnectModal] = useState(false);
    const { productModalReducer, stripeConnectReducer } = useSelector(state => state);
    const pro = useSelector(state => state?.proReducer);
    const newUser = useSelector(state => state?.newUserReducer);
    const planType = useSelector(state => state?.plantypeReducer);
    const [confirmationModalShow, setconfirmationModalShow] = useState({ show: false, text: null, deleteAll: null});
    const [isConfirmMessage, setisConfirmMessage] = useState(false);
    const [connectModal, setconnectModal] = useState(false);
    const [disconnectModal, setdisconnectModal] = useState(false);
    const [showProductType, setShowProductType] = useState(false);
    const [activeFilter, setActiveFilter] = useState('all');
    const [showModalasd, setShowModalasd] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [showModal, setShowModal] = useState({show:false})
    const isEligiblie = useSelector(state => state?.eligibilityReducer);
    const [showCreateProduct, setShowCreateProduct] = useState(false);
    const [filter, setfilter] = useState({
        page: 1,
        orderBy: null,
        filter: null,
        orderType: "asc"
    })
    // useEffect(() => {
    //     if (!pro) {
    //         setShowModalasd(true);
    //     }else if(newUser && planType != "ultra"){
    //         setShowModalasd(true);
    //     }else {
    //         setShowModalasd(false);
    //     }
    // }, [pro, planType]);
    const openProductType = (e) => {
        e.preventDefault();
        localStorage.removeItem('product_id');
        localStorage.removeItem('edit');
        setShowCreateProduct(true)
        history.push({
            pathname: `${basePath}/campaigns/addCampaigns`,
            state: { show: true,checkout1: true}
        })
        // setShowProductType(true)
    }
    const closeProductType = () => {
        // setShowProductType(false)
        setShowCreateProduct(false)
        history.push({
            pathname: `${basePath}/campaigns`,
            state: { show: true,checkout1: true}
        })
    }

    useEffect(() => {
    // if (!pro) {
    //     setShowModalasd(true);
    // }else {
    //     setShowModalasd(false);
        params = [];
        if (slug) {
            for (const key in filter) {
                if (Object.hasOwnProperty.call(filter, key)) {
                    if (filter[key])
                        params.push(`${[key]}=${filter[key]}`)
                }
            };
            if (filter?.page) callAllProducts()
        }
    // }
    }, [slug, filter,pro, planType]);

    const callAllProducts = () => {
        getProducts(slug, params?.join("&")).then((response) => {
            setloading(false)
            setallProducts(response);
        })
    }

    const filterToggler = (e, value) => {
        setfilter({
            ...filter,
            "orderBy": !$(e.target).hasClass("sortable-col-desc") ? value : value,
            orderType: !$(e.target).hasClass("sortable-col-desc") ? "desc" : "asc"
        })
        if ($(e.target).hasClass('sortable-col-desc')) {
            $('.sortable-col').removeClass('sortable-col-desc');
        }
        else {
            $('.sortable-col').removeClass('sortable-col-desc');
            $(e.target).addClass('sortable-col-desc');
        }
    }

    const deleteProduct = (id) => {
        const api = apiUrl + "/ProductFlow/delete/" + id;
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "DELETE",
            headers: myHeaders,
        }
        productPosts(api, hideLoader, setOptions).then(() => {
            setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
            callAllProducts();
        }).catch((err) => {

            // console.log(err);
            setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
        })

    }
    const deleteAllProducts = () => {
        // showLoader();
        const api = apiUrl + "/ProductFlow/delete-all/" + slug;
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "DELETE",
            headers: myHeaders,
        }
        productPosts(api, hideLoader, setOptions).then(() => {
            setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
            callAllProducts();
            setSelectAll(false)
        }).catch(() => {
                setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
                hideLoader()
            })
    }
    const copyEmail = (email) => navigator.clipboard.writeText(`${pageUrl}/${slug}/${email}`).then((response => toast.success("Successfully Copied")))

    const editProduct = async (values) => {
        // console.log("values",values);
        // const api = apiUrl + "/ProductFlow/edit/" + values?.id;
        // var myHeaders = new Headers();
        // myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        // const setOptions = {
        //     method: "GET",
        //     headers: myHeaders,
        // }

        // productPosts(api, hideLoader, setOptions).then((response) => {
        // dispatch({
        //     type: "SET_NEW_PRODUCT_DETAILS", payload: {
        //         ...productModalReducer, ...response,
        //         title: response?.name, description: JSON.parse(response?.description) ,
        //         cover_image_data_url: response?.cover_image, pricingType: response?.price > 0 ? "paid" : "free" , theme: response?.theme_id,
        //         editorjs_template_json: response?.editorjs_template_json
        //     }
        // })
        // dispatch({
        //     // type: "SET_NEW_PRODUCT_DETAILS", payload: {
        //     //     ...productModalReducer,
        // setTitle(values?.name)
        //         description: values?.description,
        //         cover_image_data_url: values?.cover_image,
        //         pricingType: values?.price > 0 ? "paid" : "free",
        //         theme: values?.theme_id,
        //         editorjs_template_json: values?.editorjs_template_json,
        //         short_description: values?.short_description,
        //         cover_image: values?.cover_image,
        //         price: values?.price,
        //         content: values?.content,
        //         content_url: values?.content_url,
        //         content_file: values?.content_file,
        //         cover_image_data_url: values?.cover_image
        //     }
        // })
        setIsEdit({ is: true, id: values?.id })
        sessionStorage.setItem("isEdit", JSON.stringify(isEdit))
        // history.push(basePath + "/createProducts");

        history.push({
            pathname: basePath + "/editCampaign", state: {
                product_id: values?.id,
                edit: { is: true, id: values?.id }
            }
        });
        // history.push({
        //     pathname: basePath + "/createProducts", state: {
        //         product_id:values?.id,
        //         edit: isEdit, name: values?.name,
        //         shortdescription: values?.short_description,
        //         maintimezone: values?.timezone,
        //         pricetype: values?.price_type,
        //         product: values?.product_theme,
        //         mainaccent: values?.accent_theme,
        //         buybut: values?.buy_button_text,
        //         faqHeading: values?.FAQ_heading,
        //         mainprice: values?.price,
        //         minprice: values?.price,
        //         suggestedprice: values?.suggested_price,
        //         mainslug: values?.slug,
        //         maincontent: values?.content,
        //         contentfilename: values?.content_file_name,
        //         contenturl: values?.content_url,
        //         maincheckout: values?.checkoutquestion,
        //         coverimg: values?.cover_images,
        //         mainfaq: values?.product_faqs,
        //         maincalendar: values?.calendar,
        //         email_Template_Markup:values?.description,
        //         editorJS_Template_Markup:values?.editorjs_template_json,
        //         availabilities_days: values?.availabilities_days


        //     }
        // });console.log("availabilities_days",values?.availabilities_days)
        // }).catch((err) => console.log(err))

    }

    const onConnect = (e) => {
        if (stripeConnectReducer?.productType === "paid" && stripeConnectReducer?.paypal === 0 && stripeConnectReducer?.stripe === 0) {
            setconnectModal(false)
            setpayoutSettingsModal(true)
        }
        else upgradeSubmit(e, null, slug, "connect")
    }

    const onDisconnect = (e) => {
        e.preventDefault();
        disconnectPayout(e, slug, setdisconnectModal);
    }

    const connectStripe = (e) => {
        upgradeSubmit(e, null, slug, "connect", "stripe")
    }
    const connectPayPal = (e) => {
        upgradeSubmit(e, null, slug, "connect", "paypal")
    }

    // const checkProductType = (val) => {
    //     if ((val?.content == 'files' || val?.content == 'url') && val?.price > 0) {
    //         return "Digital Product";
    //     }
    //     else if ((val?.content == 'files' || val?.content == 'url') && val?.price == 0){
    //         return "Lead Magnet";
    //     }
    //     else if(val?.content == 'calender'){
    //         return "Meeting";
    //     }
    // }
    const selectFilter = (e) => {

        const value = e.target.dataset?.value !== "all-products" ? e.target.dataset?.value?.toLowerCase() : null;
        setfilter({ ...filter, filter: value, page: 1 });
        setActiveFilter(value);
    }
    const upgradeHandleClick = (e) => {
        e.preventDefault();
        history.push(basePath + "/settings")
    }
    const showExportModal = (val) => {
        setShowModal({show:true,product_id:val?.id});
    };
    return (
        <>
            <div id="wrapper">
                <PageHeader />
                <div class="monetization-main new-sidebar">
                    <NewSideBar from="products" />

                    {/* <SideBar from="products" setpayoutSettingsModal={setpayoutSettingsModal} /> */}
                    <section class="monetization-section">
                        <div class="section-header sec-head-u">
                            <h1 class="mb-0">Campaigns</h1>
                            <div className="d-flex full-flex">
                                <HeaderSearch filter={filter} setfilter={setfilter} name="campaigns" />
                                <div class="align-items-center justify-content-end">
                                    <button class="project-blue-btn" id="btn-newProductModal" onClick={openProductType}>
                                        <img src={plusIcon} width="10px" alt="" />
                                        New Campaign
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* {showModalasd && <Teammoadal showModal={showModalasd} upgradeHandleClick={upgradeHandleClick} heading={'Upgrade to access Products.'} text={' Products is a Pro Feature<br /> Upgrade to Zaap Pro to unlock this feature.'} isUltra={false}/>} */}
                        {!allProducts?.data?.length > 0 && !showModalasd?
                            <div class="section-main sec-main-u p-0 position-relative">
                                <EmptyState from={"products"} firstText={'Create your first campaign'} secondText={"You don’t have any campaigns just yet. Click create to start sending custom pages."} buttonText={"Create Campaign"} clickedFunction={openProductType}/>
                            </div>
                        :
                        <div class="section-main sec-main-u">
                            {/* <div class="d-flex align-items-center justify-content-between">

                                <div className="products-filter">
                                    <span className={`${activeFilter === 'all' ? 'active' : ''} me-2`} onClick={selectFilter} data-value="all">  All products    </span>
                                    <span className={`${activeFilter === 'meeting' ? 'active': ''} me-2`} onClick={selectFilter} data-value="meeting">  Meetings        </span>
                                    <span className={`${activeFilter === 'lead' ? 'active': ''} me-2`}   onClick={selectFilter} data-value="lead">  Lead Magnets    </span>
                                    <span className={`${activeFilter === 'digital' ? 'active': ''}`} onClick={selectFilter} data-value="digital">  Digital Products</span>
                                </div>
                            </div> */}
                            <div class="d-flex table-responsive gap-3 flex-wrap ">
                                    {
                                        loading ?

                                            <tbody>

                                                <tr>
                                                    <td class="d-md-table-cell">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        />
                                                    </td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {/* <img src={dotsIcon} width="" alt="" /> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        />
                                                    </td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {/* <img src={dotsIcon} width="" alt="" /> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        />
                                                    </td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {/* <img src={dotsIcon} width="" alt="" /> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        />
                                                    </td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {/* <img src={dotsIcon} width="" alt="" /> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        />
                                                    </td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {/* <img src={dotsIcon} width="" alt="" /> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        />
                                                    </td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {/* <img src={dotsIcon} width="" alt="" /> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        />
                                                    </td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {/* <img src={dotsIcon} width="" alt="" /> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        />
                                                    </td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <Skeleton height={40}
                                                            borderRadius="10px"
                                                            highlightColor="#ffffff"
                                                            duration={4}
                                                        /></td>
                                                    <td class="d-md-table-cell d-none">
                                                        <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {/* <img src={dotsIcon} width="" alt="" /> */}
                                                        </div>
                                                    </td>
                                                </tr>

                                            </tbody>
                                            :
                                            <>
                                            {allProducts?.data?.length > 0 && (
                                                allProducts?.data?.map((val, index) => (
                                                    <div className="campaigns fs-14px">
                                                        {
                                                            val?.logo != 'null' ?
                                                        <img width={"198px"} height={"208px"} className="campaign-template-image" src={val?.logo} alt="" />
                                                        :
                                                        <div style={{width:"198px", height:"208px"}}></div>
                                                        }
                                                        <div className="fs-14px ms-2">{val?.name}</div>
                                                        <div className="d-flex ms-2 justify-content-between gap-1">
                                                            <button className="btn-white" onClick={()=>editProduct(val)}>Edit Template</button>
                                                            <button className="btn-white" onClick={()=>showExportModal(val)}>Export Lead</button>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                            </>
                                    }
                            </div>


                            <div class="section-footer d-flex align-items-center justify-content-between">
                                <CommunityFooter filter={filter} setfilter={setfilter} total={allProducts?.total} last_page={allProducts?.last_page} current_page={allProducts?.current_page}/>
                            </div>

                        </div>
                        }
                    </section>

                </div>
            </div>
            {showModal.show &&  <ExportSteps product_id={showModal?.product_id} show={showModal} setShow={setShowModal}/>}
            {showProductType && <ProductTypeModal isOpen={showProductType} onHide={closeProductType} />}

            {payoutSettingsModal && <PayoutSettings show={payoutSettingsModal} setShow={setpayoutSettingsModal} connectStripe={connectStripe} setpayoutDisconnect={setdisconnectModal} connectPayPal={connectPayPal} stripeConnectReducer={stripeConnectReducer} />}

            {connectModal && <ConnectModal show={connectModal} setShow={setconnectModal} connect={onConnect} />}

            {disconnectModal && <DisonnectModal show={disconnectModal} setShow={setdisconnectModal} disconnect={onDisconnect} />}
        
            {showCreateProduct && <Route path={basePath + "/campaigns/:addCampaign"} children={() => <ProductMain from={"template"} onClose={closeProductType}/>}
            />}

            {confirmationModalShow?.show && <ConfirmationModal confirmationModalShow={confirmationModalShow} setShow={setconfirmationModalShow} setisConfirmMessage={setisConfirmMessage} callback={confirmationModalShow?.deleteAll ? deleteAllProducts :deleteProduct} />}
        </>
    )
}
export default Products